import { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { CommonStyle, ControlledTable, Filter2 } from "Components";
import { TableLayout } from "Layouts";
import { FilterArr, TableCol } from "./Data";
import AuditApi from "Service/Audit.api";
import { UserAuditType } from "DataTypes/Services/User.type";
import { CreateFilter2Payload } from "Utils/common";
import { FetchListProps, Filter2DataProps } from "DataTypes/Common";
import UserFormatter from "Utils/Users.Formatter";
import { RouteUrls } from "Constant/RouteUrls";
import CommonFormatter from "Utils/Common.Formatter";
import { useDispatch, useSelector } from "react-redux";
import { ScreenInitialStateType } from "DataTypes/Redux";
import { setPageLimit } from "Redux/Screen/Action";

const UserAuditTrail: FC = () => {
  const dispatch = useDispatch();
  const { listPagination }: ScreenInitialStateType = useSelector(
    (state: any) => state?.screen
  );
  const reduxLimit =
    (listPagination || []).find(el => el.id == "user-audit-trail")?.limit || 10;

  const [limit, setLimit] = useState<number>(reduxLimit);
  const [totalRecord, setTotalRecord] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [rows, setRows] = useState<UserAuditType[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filterHeight, setFilterHeight] = useState<number>(0);
  const [filterData, setFilterData] = useState<Filter2DataProps[]>(
    JSON.parse(JSON.stringify(FilterArr()))
  );
  const tableHeight = `calc(99% - ${filterHeight}px)`;

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "user-audit-trail",
      label: "User Audit Trail",
      path: `/${RouteUrls.hs}/${RouteUrls.userAudit}`,
      level: 1,
      link: RouteUrls.userAudit,
      navType: "my-items",
    });
  }, []);

  useEffect(() => {
    handleSetData({ page: 1, limit });
  }, [filterData]);

  const handleSetData: (props: FetchListProps) => void = async (props) => {
    const { page: currentPage, limit: currentLimit } = props;
    const newFilterPayload = CreateFilter2Payload(filterData);
    const payload = {
      ...(newFilterPayload || {}),
    };
    setLoading(true);
    const res: any = await AuditApi.userAudit({
      data: payload,
      limit: currentLimit,
      offset: (currentPage - 1) * currentLimit,
    });
    if (res?.success) {
      setRows(UserFormatter.VerifyLogRes(res?.data));
      setPage(res.criterion.page);
      setTotalRecord(res?.criterion?.total);
      setLimit(res?.criterion?.limit);
      dispatch(
        setPageLimit({ id: "user-audit-trail", limit: res?.criterion?.limit })
      );
    } else {
      setRows([]);
      setPage(1);
      setTotalRecord(0);
      setLimit(10);
    }
    setLoading(false);
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol()}
      tableRow={rows}
      searchText={searchText}
    />
  );

  return (
    <Box
      height="91%"
      sx={{ ...CommonStyle.sxWhiteBox, px: 2, overflow: "auto" }}
    >
      <Filter2
        filterDataArr={filterData}
        handleFilterClick={(data) => setFilterData(data)}
        changeSearchText={(val) => setSearchText(val)}
        setFilterHeight={(val) => setFilterHeight(val)}
      />
      <TableLayout
        tblBody={TblBodyJSX}
        tblHead={ControlledTable.TblHead(TableCol(), true)}
        height={tableHeight}
        loading={loading}
        Pagination={
          <ControlledTable.Pagination
            mainPage={page}
            limit={limit}
            total={totalRecord}
            handleClick={(currentPage, currentLimit) =>
              handleSetData({ page: currentPage, limit: currentLimit })
            }
            tableStyle={true}
          />
        }
      />
    </Box>
  );
};
export default UserAuditTrail;
